import React from 'react';
import { Button, Modal } from 'reactstrap';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { TypedMemo } from '../../../types';
import { ClickableDiv } from '../../ClickableDiv';
import { SMLModalProps } from './props';

const SMLModalComponent: React.FC<React.PropsWithChildren<SMLModalProps>> = ({
  isOpen,
  children,
  onClosed,
  onClick,
  size,
  customModal = false,
  ariaLabel,
}) => {
  return (
    <Modal
      size={size ?? 'lg'}
      isOpen={isOpen}
      toggle={onClosed}
      className="sml-modal-container"
      centered
      aria-label={ariaLabel}
    >
      <div className="sml-modal-close">
        <Button onClick={onClosed} color="link" aria-label="Close">
          <FontAwesomeIcon icon={faTimesCircle} color="black" />
        </Button>
      </div>
      <ClickableDiv onClick={onClick} className={clsx({ 'sml-modal-content': !customModal })}>
        {children}
      </ClickableDiv>
    </Modal>
  );
};

export const SMLModal = TypedMemo(SMLModalComponent);
